(ns frontend.view.ai-summary-library.model
  "Pure state helpers for the AI Summary Library page."
  (:require
   [clojure.string :as string]
   [frontend.ui.ai-summary-configuration.model :as configuration-model]))

(def root-path [::state])

(defn initial-state
  []
  {:load-state :loading
   :configurations []
   :query ""
   :selected-configuration-id nil
   :detail-state :idle
   :configuration-detail nil
   :mode :selected
   :draft nil
   :saved-draft nil
   :copy-source-name nil
   :save-state :idle
   :uploading-field nil})

(defn filtered-configurations
  [{:keys [configurations query]}]
  (let [query (string/lower-case (string/trim (or query "")))]
    (if (string/blank? query)
      configurations
      (filterv
       (fn [{:keys [configuration-name configuration-description]}]
         (or (string/includes? (string/lower-case (or configuration-name ""))
                               query)
             (string/includes?
              (string/lower-case (or configuration-description ""))
              query)))
       configurations))))

(defn selected-configuration
  [{:keys [configurations selected-configuration-id]}]
  (some (fn [configuration]
          (when (= selected-configuration-id (:id configuration))
            configuration))
        configurations))

(defn owner-edit?
  [{:keys [mode configuration-detail]}]
  (and (= :selected mode)
       (:owned-by-requester? configuration-detail)))

(defn copy-mode?
  [{:keys [mode configuration-detail]}]
  (or (= :copy mode)
      (and (= :selected mode)
           configuration-detail
           (not (:owned-by-requester? configuration-detail)))))

(defn save-enabled?
  [{:keys [mode draft saved-draft uploading-field] :as state}]
  (and (nil? uploading-field)
       (configuration-model/draft-valid? draft)
       (case mode
         :create true
         :copy (configuration-model/copy-name-valid?
                draft
                (:copy-source-name state))
         :selected (if (owner-edit? state)
                     (configuration-model/draft-dirty? draft saved-draft)
                     false)
         false)))

(defn save-request
  [{:keys [mode draft selected-configuration-id] :as state}]
  (let [owner-edit? (owner-edit? state)
        create? (contains? #{:create :copy} mode)
        copy? (or (= :copy mode)
                  (and (= :selected mode) (not owner-edit?)))]
    (when (save-enabled? state)
      (if (or create? copy?)
        {:operation :entity/create-entity
         :body (if copy?
                 (configuration-model/private-copy-data draft)
                 (configuration-model/create-data draft))}
        {:operation :entity/update-attributes
         :body {:db/id selected-configuration-id
                :data (configuration-model/update-data draft)}}))))
